import React, {Fragment, useState} from 'react';
import './App.css';
import {HashRouter, Route, Switch} from "react-router-dom";
import {Overview} from "./components/Overview";
import {Footer} from "./components/Footer";
import LanguageContext from "./context/language";
import {People} from "./components/People";
import {Projects} from "./components/Projects";
import Navbar from "./components/Navbar";
import {Resources} from "./components/Resources";
import {SchoolOverview} from "./components/Iran/Overview";
import {Programme} from "./components/Iran/Programme";
import {Admission} from "./components/Iran/Admission";
import {Preparations} from "./components/Iran/Preparations";
import {Seasons} from "./components/Iran/Seasons";
import {Comments} from "./components/Iran/Comments";
import {Gallery} from "./components/Iran/Gallery";

function App() {
    const [language, setLanguage] = useState('en');

    return (
        <Fragment>
            <LanguageContext.Provider value={{language, changeLanguage: setLanguage}}>
                <HashRouter>
                    <Navbar />
                    <Switch>
                        <Route path='/' component={Overview} exact={true}/>
                        <Route path='/overview' component={Overview} />
                        <Route path='/people' component={People} />
                        <Route path='/projects' component={Projects} />
                        <Route path='/resources' component={Resources} />
                        <Route path='/summer-school-iran/' exact={true} component={SchoolOverview} />
                        <Route path='/summer-school-iran/overview' component={SchoolOverview} />
                        <Route path='/summer-school-iran/programme' component={Programme} />
                        <Route path='/summer-school-iran/admission' component={Admission} />
                        <Route path='/summer-school-iran/preparations' component={Preparations} />
                        <Route path='/summer-school-iran/seasons' component={Seasons} />
                        <Route path='/summer-school-iran/comments' component={Comments} />
                        <Route path='/summer-school-iran/gallery' component={Gallery} />
                        <Route path='/summer-school-iran/*' component={SchoolOverview} />
                        <Route path='*' component={Overview} />
                    </Switch>
                </HashRouter>
                <Footer/>
            </LanguageContext.Provider>
        </Fragment>
    );
}

export default App;
